import { Injectable, Input } from "@angular/core";
import { openAlertButtonsArray, openAlertFn, openAlertPersonalizedButtons } from "../closures";
import { AlertType, DynamicComponentService } from "@shared/components/atomics/body-loading/dynamic-component-service.service";
import { TranslateService } from "@core/api/translate.service";
import { PersonalizedAlertButton } from "@shared/components/atomics/body-loading/personalized-button";

@Injectable({
 providedIn: 'root',
})
export class AlertsFunctions{
    private openAlert = openAlertFn(this.dynamicComponentService, 'htmlContent');
    private openAlertPersonalizedButtons = openAlertPersonalizedButtons(this.dynamicComponentService, 'htmlContent');
    private openAlertButtonsArray = openAlertButtonsArray(this.dynamicComponentService, 'htmlContent');
    constructor(
      private dynamicComponentService: DynamicComponentService,
      private translateService: TranslateService,
    ){}
    showAlertWithButtons(message: string, title:string = this.translateService.instant('warning','Aviso')): Promise<boolean>{
      return new Promise(resolve => {
        const alert = this.openAlert(
          title,
          message,
          AlertType.warning,
          false,
          true,
          true,
          () => {
            alert.unsubscribe();
          }
        ).subscribe(({
          next: (value) => {
            resolve(typeof value === 'object' && 'result' in value ? value.result : value);
          },
        }))
      })
    }
    showAlertWithYesNoButtons(message: string, title:string = this.translateService.instant('warning','Aviso')): Promise<boolean>{
      return new Promise(resolve => {
        const alert = this.openAlertPersonalizedButtons(
          title,
          message,
          AlertType.warning,
          false,
          true,
          true,
          {
            textSuccessButton: this.translateService.instant('yes','Si'),
            textCancelButton: this.translateService.instant('no','No')
          },
          () => {
            alert.unsubscribe();
          }
        ).subscribe(({
          next: (value) => {
            resolve(typeof value === 'object' && 'result' in value ? value.result : value);
          },
        }))
      })
    }
    showInfoAlert(message: string, title: string = this.translateService.instant('information','Información')): Promise<boolean>{
      return new Promise(resolve => {
        const alert = this.openAlert(
          title,
          message,
          AlertType.info,
          false,
          true,
          false,
          () => { alert.unsubscribe(); }
        ).subscribe();
      })
    }
    showErrorAlert(message: string, title: string = this.translateService.instant('error','Error')): Promise<boolean>{
      return new Promise(resolve => {
        const alert = this.openAlert(
          title,
          message,
          AlertType.error,
          false,
          true,
          false,
          () => { alert.unsubscribe(); }
        ).subscribe();
      })
    }
    showWarningAlert(message: string, title: string = this.translateService.instant('advice','Aviso')): Promise<boolean>{
      return new Promise(resolve => {
        const alert = this.openAlert(
          title,
          message,
          AlertType.warning,
          false,
          true,
          false,
          () => { alert.unsubscribe(); }
        ).subscribe();
      })
    }
    showSuccessAlert(message: string, title: string = this.translateService.instant('correct','Correcto')): Promise<boolean>{
      return new Promise(resolve => {
        const alert = this.openAlert(
          title,
          message,
          AlertType.success,
          false,
          true,
          false,
          () => { alert.unsubscribe(); }
        ).subscribe();
      })
    }
    showAlertWithButtonsPersonalized(message: string, title:string = this.translateService.instant('warning','Aviso'), buttons: PersonalizedAlertButton[]): Promise<boolean>{
      return new Promise(resolve => {
        const alert = this.openAlertButtonsArray(
          title,
          message,
          AlertType.warning,
          false,
          true,
          true,
          () => {
            alert.unsubscribe();
          },
          buttons
        ).subscribe(({
          next: (value) => {
            resolve(typeof value === 'object' && 'result' in value ? value.result : value);
          },
        }))
      })
    }
}